/* eslint-disable eqeqeq */
import React, { Component } from 'react';
import Web3 from 'web3';

const stakingContractAddress = '0x7e9F6b7135a88c192494911Efd474dB9De2b3317';
const contractAbi = [{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burnFor","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"claim","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"isAddress","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"contractAddress","type":"address"}],"name":"setShares","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"contractAddress","type":"address"}],"name":"setToken","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"sharesToken","outputs":[{"internalType":"contract SharesInterface","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"stake","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"stakingStats","outputs":[{"internalType":"uint256","name":"staked","type":"uint256"},{"internalType":"uint256","name":"rewards","type":"uint256"},{"internalType":"uint256","name":"stakingBlock","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"token","outputs":[{"internalType":"contract IBEP20","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"unstake","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}];


class SubModal extends Component {
  constructor(props) {
    super(props);
    this.state = { }
  }

  async stake(amount){
    if (window.ethereum) {
      try {
          // Request account access
          await window.ethereum.enable();
      } catch (error) {
          // User denied account access...
          alert('You must connect your wallet !')
          return;
      }
    }else {
        // you cant connect
        console.error("Unable to connect to metamask");
        alert("You have to use Trustwallet app or install Metamask extension in your browser to use this app, you can install it from :  https://metamask.io/download.html");
        return;
    }

    let web3 = new Web3(window.ethereum);
    let accounts = await web3.eth.getAccounts();
    let account = accounts[0];
    let myContract = new web3.eth.Contract(contractAbi, stakingContractAddress);
    await myContract.methods.stake(Web3.utils.toWei(amount)).send({
        from : account
    });
    window.location.reload();
  }

  async unstake(amount){
    if (window.ethereum) {
      try {
          // Request account access
          await window.ethereum.enable();
      } catch (error) {
          // User denied account access...
          alert('You must connect your wallet !')
          return;
      }
    }else {
        // you cant connect
        console.error("Unable to connect to metamask");
        alert("You have to use Trustwallet app or install Metamask extension in your browser to use this app, you can install it from :  https://metamask.io/download.html");
        return;
    }

    let web3 = new Web3(window.ethereum);
    let accounts = await web3.eth.getAccounts();
    let account = accounts[0];
    let myContract = new web3.eth.Contract(contractAbi, stakingContractAddress);
    await myContract.methods.unstake(Web3.utils.toWei(amount)).send({
        from : account
    });
    window.location.reload();
  }


  render() { 
    return ( 
      <div className="doCenter">
        <div style={{ width: "80%", color: "#00000066" }} className="modal-box">
          <div
            style={{
              marginBottom: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span>{""}</span>
            <span style={{ marginLeft: "1vw" }}>                                              {//TODO: check 10**18
              this.props.status === 1 ? this.props.available.toFixed(4) : (this.props.stacked/(10**18)).toFixed(4)}APYD-BNB Available
            </span>
          </div>
          <div
            className="input-box"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <input
              type="number"
              value={this.props.val}
              placeholder={this.props.status == 1 ? "DEPOSIT" : "WITHDRAW"}
              id="inputID"
              onChange={(e) => this.props.setVal(e.target.value)}
            />
            <span
              style={{
                fontSize: "1.1em",
                fontWeight: "bold",
                marginRight: "10px",
                color: "#00000095",
              }}
            >
              APYD-BNB
            </span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div
              className="button2"
              style={{
                background: "#cccccc",
                padding: "10px 15px",
                fontStyle: "italic",
                margin: "10px 0",
                width: "32%",
                color: "#2b221f8c",
              }}
              onClick={() => this.props.setModal(false)}
            >
              CANCEL
            </div>
            <div
              className="button2"
              onClick={() => {
                if(this.props.status == 1){
                  this.stake(this.props.val.toString())
                }else{
                  this.unstake(this.props.val.toString())
                }
              }}
              style={{
                padding: "10px 15px",
                fontStyle: "italic",
                margin: "10px 0",
                width: "32%",
                color: "#2b221fb3",
              }}
            >
              CONFIRM
            </div>
          </div>
        </div>
        <div>
          <div className="button2 max doCenter" onClick={() => this.props.setValMax(this.props.status)} >MAX</div>
        </div>
      </div>
    );
  }
}
 
export default SubModal;